export const administrationAccountsDepartmentEmployees = {
    template: require('./administration-accounts-department-employees.html'),
    controller: 'AdministrationAccountsDepartmentEmployeesController'
};
